import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { glossaryKeys } from '@/shared/lib/query/queryKeys/glossary';

import { type GetGlossaryTermResponse, getGlossaryTermTreeApi } from '@/features/glossary/api/getGlossaryTermApi';

type UseGlossaryTermParams = {
  directChildrenOf?: string;
};

export const useGlossaryTerm = ({ directChildrenOf = '' }: UseGlossaryTermParams) => {
  return useQueryWithBoundary({
    queryKey: glossaryKeys.terms(directChildrenOf),
    queryFn: async (): Promise<GetGlossaryTermResponse> => {
      return await getGlossaryTermTreeApi({ directChildrenOf });
    },
    enabled: !!directChildrenOf,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
